import React from 'react';
import { connect } from 'react-redux';
import { List, Collapse } from '@mui/material';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import SwitchListItem from '../../../../../../list-items/SwitchListItem';
import VisualizerDriftIntensitySlider from './VisualizerDriftIntensitySlider';
import VisualizerDriftAmplitudeXListItem from './VisualizerDriftAmplitudeXListItem';
import VisualizerDriftAmplitudeYListItem from './VisualizerDriftAmplitudeYListItem';
import VisualizerDriftRotationListItem from './VisualizerDriftRotationListItem';
import VisualizerDriftFrequencyListItem from './VisualizerDriftFrequencyListItem';
import VisualizerDriftScaleListItem from './VisualizerDriftScaleListItem';
import VisualizerDriftAccelerationListItem from './VisualizerDriftAccelerationListItem';
import { interpolateVisualizerDrift, estimateIntensity, VISUALIZER_ANCHORS } from '../../../../Preview/effects/drift/driftUtilities';

const VisualizerDriftListItem = (props) => {
    const { drift, driftEnabled, customizeOpen, updateVisualizerSettings } = props;

    const onEnabledChange = (value) => updateVisualizerSettings({ drift: { enabled: value } });

    const onCustomizeChange = (value) => {
        if (value) {
            const params = interpolateVisualizerDrift(drift.intensity ?? 0);
            updateVisualizerSettings({ drift: { ...params, customMode: true } });
        } else {
            const intensity = estimateIntensity(drift, VISUALIZER_ANCHORS) ?? drift.intensity ?? 0;
            updateVisualizerSettings({ drift: { intensity, customMode: false } });
        }
    };

    return (
        <CollapsibleSwitchListItem
            checked={driftEnabled}
            text='Drift'
            toolTip='The visualizer moves and tilts randomly with smooth motion. Loud audio increases movement speed.'
            onChange={onEnabledChange}
            expansionEnabled={true}
        >
            <List dense disablePadding>
                <VisualizerDriftIntensitySlider />
                <SwitchListItem 
                    text='Custom' 
                    checked={customizeOpen} 
                    onChange={(e) => onCustomizeChange(e.target.checked)} 
                />
                
                <Collapse in={customizeOpen} timeout="auto" unmountOnExit>
                    <CondensedListItem
                        elements={[
                            { width: 6, component: <VisualizerDriftAmplitudeXListItem /> },
                            { width: 6, component: <VisualizerDriftAmplitudeYListItem /> }
                        ]}
                    />
                    <CondensedListItem
                        elements={[
                            { width: 6, component: <VisualizerDriftRotationListItem /> },
                            { width: 6, component: <VisualizerDriftScaleListItem /> }
                        ]}
                    />
                    <CondensedListItem
                        elements={[
                            { width: 6, component: <VisualizerDriftFrequencyListItem /> },
                            { width: 6, component: <VisualizerDriftAccelerationListItem /> }
                        ]}
                    />
                </Collapse>
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const drift = state.createPreview.present.videoSettings.visualizer.drift;
    const customizeOpen = Boolean(drift.customMode);
    return {
        drift,
        driftEnabled: drift.enabled,
        customizeOpen
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return {
        updateVisualizerSettings
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftListItem);
